import { Typography, WithInfoIcon } from 'seagull';
import { useTestIds } from 'seagull/utils/TestIds';
import { useStore } from "../../../contexts";
import { serviceModel } from "../../../models";
import { selectors } from "../../../store/state-selectors";
import { utils } from "../../../utils";
import styles from "./PriceDisplay.module.scss";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function PriceDisplay(props) {
  const {
    service,
    priceAfterDiscount,
    priceBeforeDiscount,
    postfixPrice,
    error,
    'data-testid': testid = ''
  } = props;
  const isVendor = useStore(selectors.user.isVendor);
  const {
    PriceDisplayTID
  } = useTestIds(testid);
  const skin = defaultSkin => error ? 'error' : defaultSkin;
  const includedServices = serviceModel.includedServices(service);
  const hasIncludedServices = !!includedServices && includedServices.length > 0;
  function renderBundlePriceInfo() {
    return hasIncludedServices ? /*#__PURE__*/_jsxs(Typography, {
      skin: "invertedStandard",
      "data-testid": PriceDisplayTID.BundlePriceInfo(),
      children: [/*#__PURE__*/_jsx(Typography, {
        skin: "invertedStandard",
        weight: "normal",
        children: "Included service rates:"
      }), "\xA0", /*#__PURE__*/_jsx("ul", {
        children: includedServices.map((includedService, index) => /*#__PURE__*/_jsxs("li", {
          className: styles.infoBullet,
          "data-testid": PriceDisplayTID.BundlePriceInfoItem(index),
          children: [includedService.name, " (", utils.formatDollarAmount(utils.applyDiscount(includedService.rate, service.cost.discount)), ")"]
        }, includedService.id))
      }), "\xA0", /*#__PURE__*/_jsx(Typography, {
        skin: "invertedStandard",
        children: "Included service rates are hidden from your client."
      })]
    }) : /*#__PURE__*/_jsx(_Fragment, {});
  }
  return /*#__PURE__*/_jsxs(WithInfoIcon, {
    info: renderBundlePriceInfo(),
    showInfo: isVendor && hasIncludedServices,
    infoTestId: PriceDisplayTID.BundlePriceInfoIcon(),
    className: styles.price,
    placement: "right",
    "data-testid": testid + 'price',
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.priceAndUnit,
      "data-testid": testid + 'price-after-discount',
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "h4",
        skin: skin('standard'),
        children: priceAfterDiscount
      }), postfixPrice && /*#__PURE__*/_jsx(Typography, {
        variant: "paragraph2",
        skin: skin('secondary'),
        children: postfixPrice
      })]
    }), priceBeforeDiscount && /*#__PURE__*/_jsx("div", {
      "data-testid": testid + 'price-before-discount',
      children: /*#__PURE__*/_jsx(Typography, {
        skin: skin('secondary'),
        textDecoration: "line-through",
        children: priceBeforeDiscount
      })
    })]
  });
}